import $ from 'jquery';

export default () => {
    loadMoreForAll();

    $('.js-what-we-ve-done-filter #cohort').on('change', removeLoadMore);
    $('.js-what-we-ve-done-filter #cohort-entities').on('change', removeLoadMore);
    $('.js-media-gallery-filter #cohort').on('change', removeLoadMore);
    $('.js-media-gallery-filter #cohort-year').on('change', removeLoadMore);
};

function removeLoadMore() {
    var cohort = $('#cohort').val();
    var year = $('.js-media-gallery-filter #cohort-year').val();
    var entities = $('#cohort-entities').val();
    $('.load-more').off('click');

    if (cohort == '' && (year == '' ||  entities == '')) {
        loadMoreForAll();
    } else if (cohort != '') {
        $('.load-more').hide();
    } else {
        var visibleSliders = $(".js-slider").filter(function() {
            return $(this).css("display") != "none";
        });
        
        if ($(visibleSliders).length <= 2) {
            $('.load-more').hide();
        } else {
            var slidersForThisYear = visibleSliders;
            slidersForThisYear.each((index, slider) => {
                if (index < 2) {
                    $(slider).show();
                    $(slider).find(".js-slick").slick("setPosition");
                } else {
                    $(slider).hide();
                    $('.load-more').css("display", "flex");
                }
            });
            $(".load-more").on("click", function() {
                var yetToShowSliders = slidersForThisYear.filter(function() {
                    return $(this).css("display") == "none";
                });
                if ($(yetToShowSliders).length <= 2) {
                    $('.load-more').hide();
                }
                yetToShowSliders.each((index, slider) => {
                    if (index < 2) {
                        $(slider).show();
                        $(slider).find(".js-slick").slick("setPosition");
                    } else {
                        $(slider).hide();
                        $('.load-more').css("display", "flex");
                    }
                });
            });
        }
    }
}

function loadMoreForAll() {
    if ($(".js-slider").length > 3) {
        $(".js-slider:gt(1)").hide();
        $(".load-more").css("display", "flex");
    }
    $(".load-more").on("click", function() {
        var moreSliders = $(".js-slider").filter(function() {
            return $(this).css("display") == "none";
        });
        if (moreSliders.length <= 2) {
            $(".load-more").hide();
        }
        if (moreSliders.length > 0) {
            moreSliders.each((index, slider) => {
                if (index < 2) {
                    $(slider).show();
                    $(slider).find(".js-slick").slick("setPosition");
                }
            });
        }
    });
}